import {SERVER_API_PLATFORMJK} from '../../constans/index';
import {
    TRIGGER_UPDATE_REQUEST,
    TRIGGER_UPDATE_SUCCESS,
    TRIGGER_UPDATE_FAILURE,
} from '../../types/index';
import {RSAA} from 'redux-api-middleware';
import headers from "../../utils/headers";

const UpdateTriggerAction = (id,data_target) => ({

    [RSAA]: {
        endpoint: `${SERVER_API_PLATFORMJK}/api/v2/triggers/${id}`,
        method: 'PUT',
        headers: (headers()),
        body: (() => {
            return JSON.stringify(data_target);
        }),
        types: [
            TRIGGER_UPDATE_REQUEST,
            {
                type: TRIGGER_UPDATE_SUCCESS,
                payload: async (action, state, res) => {
                    const contentType = res.headers.get('Content-Type');
                    let data = [];
                    if (contentType && ~contentType.indexOf('json')) {
                        await res.json().then((json) => {
                            data = json.data
                        });
                        return {
                            "code": 0,
                            "type": TRIGGER_UPDATE_SUCCESS,
                            "data": data
                        }
                    }

                }
            },
            {
                type: TRIGGER_UPDATE_FAILURE,
                payload: async (action, state, res) => {

                    let message = "";
                    await res.json().then((json) => {
                        message = json.message;
                    });

                    return {
                        "code": 1,
                        "type": TRIGGER_UPDATE_FAILURE,
                        "message": message,
                        "data": [],
                    }
                }
            }
        ]
    }

});

export {UpdateTriggerAction}